import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {publicRoutes} from './PublicRoutes';
import {protectedRoutes} from './ProtectedRoutes';

/**
 * Routes principales de l'application
 * Combine les routes publiques et protégées de manière organisée
 */
const AppRoutes = () => {
  return (
    <Routes>
      {/* Routes publiques */}
      {publicRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={route.element}
        />
      ))}

      {/* Routes protégées */}
      {protectedRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={route.element}
        >
          {/* Routes enfants */}
          {route.children &&
            route.children.map((child) => (
              <Route
                key={child.path}
                path={child.path}
                element={child.element}
              >
                {/* Sous-enfants si présents */}
                {child.children &&
                  child.children.map((subChild) => (
                    <Route
                      key={subChild.path}
                      path={subChild.path}
                      element={subChild.element}
                    />
                  ))}
              </Route>
            ))}
        </Route>
      ))}

      {/* Catch-all : redirection vers la page non trouvée */}
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
};

export default AppRoutes;